module.exports = __webpack_public_path__ + "./static/img/icondis-3.c1782fddd3778d2199668e2b08a794fb.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/img/company/icondis-3.png
// module id = ./client/src/assets/img/company/icondis-3.png
// module chunks = 0